<figure #mover [ngClass]="movingObj.whois" class="obj marg blob noselect" id="" [id]="movingObj.id">
	<svg height="100" width="100" viewBox="0 0 100 100" preserveAspectRatio="none">
		<g class="move noselect">
			<ellipse #fx class="noselect fx_war_color" cx="50%" cy="50%" rx="5%" ry="5%" fill="gray" />			
			<path #anime class="blob noselect fill_color" d="M50 50 L50 50" fill="gray" />			
			<text #text class="move-count noselect text_color" x="50%" y="50%" fill="black" dominant-baseline="middle" text-anchor="middle">{{movingObj.num}}</text>
		</g>
	</svg>
</figure>